import React from "react"
import LandingPageWithStore from "../../components/LandingPage/LandingPageWithStore"

const DefaultRoute = props => {
  return <LandingPageWithStore />
}

export default DefaultRoute
